import PasswordField from "@/components/Common/forms/PasswordField";
import useRegistrationStore from "@/store/registration";
import {type FC} from "react";
import {useTranslation} from "react-i18next";

const RegistrationPasswordField: FC = () => {
  const {t} = useTranslation();
  const errorMessage = useRegistrationStore(state => state.errors["password"]);
  const setValue = useRegistrationStore(state => state.setValue);
  const valueFromStore = useRegistrationStore(state => state["password"]);

  return (
    <PasswordField
      onChange={value => setValue("password", value)}
      error={t(errorMessage)}
      value={valueFromStore}
      label={t("Password")}
      placeholder={t("Password")}
    />
  );
};

export default RegistrationPasswordField;
